module.exports = require('./helpers/bundle-url').getBundleURL('9G649') + "dark-mode.fd95cecc.svg";